import {
  getLandingPageBySlug,
  getLandingPagesSlugs,
} from 'app/apiCalls/kentico';
import {
  getStaticProps as getStaticPropsUtil,
  getStaticPaths as getStaticPathsUtil,
  IPageData,
} from 'app/utils/kentico';
import KenticoPage from 'app/containers/KenticoPage/KenticoPage';
import PageBuilderWrapper from 'app/containers/KenticoPage/PageBuilderWrapper';
import { PageId } from 'app/shared/components/PageWrapper/providers/PageProvider/hooks/usePageId/usePageId';

interface ILandingPageProps extends IPageData {}

const LandingPage = ({ pageData, kenticoProjectId }: ILandingPageProps) => {
  const pageIdPrefix = PageId.LANDING_PAGE;
  return (
    <KenticoPage pageData={pageData} pageIdPrefix={pageIdPrefix}>
      <PageBuilderWrapper
        pageData={pageData}
        kenticoProjectId={kenticoProjectId}
      />
    </KenticoPage>
  );
};

const getStaticProps = ({ params }) => {
  return getStaticPropsUtil(params, getLandingPageBySlug);
};

const getStaticPaths = () => {
  return getStaticPathsUtil(getLandingPagesSlugs);
};

export { LandingPage, getStaticPaths, getStaticProps };
